import React from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';

import UpgradeNotice from '../../shared/UpgradeNotice';

export default function EvaluationAccessView() {
    return (
        <Box
            sx={{
                borderBottom: '1px solid',
                borderColor: 'divider',
                background: 'linear-gradient(135deg, rgba(255,165,0,0.12) 0%, rgba(0,0,0,0.06) 100%)',
                py: { xs: 6, md: 10 },
                minHeight: '100vh',
            }}
        >
            <Container maxWidth="md">
                <Stack spacing={2} alignItems="flex-start">
                    <Typography variant="h4" fontWeight={800}>
                        Steuerliche Auswertung
                    </Typography>
                    <Typography color="text.secondary">
                        Monats-, Quartals- und Jahresauswertungen sind im 20 € netto Tarif enthalten.
                    </Typography>
                    <UpgradeNotice
                        title="Steuerliche Auswertungen freischalten"
                        description="Die USt- und Einkommensteuer-Auswertungen sind Teil des Buchhaltungstarifs."
                        actionLabel="Zum Buchhaltungstarif"
                    />
                </Stack>
            </Container>
        </Box>
    );
}
